// extracted by mini-css-extract-plugin
export default {"form_search_user":"FormSearchUser_form_search_user__lm2Z4"};